import LogoPic from "images/logo.png";
import { FooterLink } from "data/types";
import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { globalJson } from "global/global_json";
import { useData } from "data/data-provider";
import { formatPhoneLabel, formatTelHref } from "utils/PhoneFormat";

export interface WidgetFooterMenu {
  id: string;
  title: string;
  menus: FooterLink[];
}

const Footer: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { ourCompany } = useData();

  const widgetMenus: WidgetFooterMenu[] = [
    {
      id: "1",
      title: "Explore",
      menus: [
        { href: "https://dfwluxauto.com/fleet", label: "Our Fleet" },
        { href: "https://dfwluxauto.com/earn-with-us", label: "Earn with Us" },
        { href: "https://dfwluxauto.com/attractions", label: "Attractions" },
        { href: "https://dfwluxauto.com/contact-us", label: "Contact Us" },
      ],
    },
    {
      id: "2",
      title: "Quick Links",
      menus: [
        {
          href: "https://dfwluxauto.com/privacy-policy",
          label: "Privacy Policy",
        },
        {
          href: "https://dfwluxauto.com/terms-of-service",
          label: "Terms of Service",
        },
        {
          href: "https://dfwluxauto.com/about-dfw-luxury-auto",
          label: "About Us",
        },
        { href: "https://dfwluxauto.com/faq", label: "FAQ" },
      ],
    },
    {
      id: "3",
      title: "Contact Us",
      menus: [
        {
          label: ourCompany?.company?.address || globalJson.address,
          href: undefined,
          icon: (
            <svg
              width="14"
              height="16"
              viewBox="0 0 14 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13.625 15C13.8125 15 14 15.1875 14 15.375V16H0V15.375C0 15.1875 0.15625 15 0.375 15H1V0.75C1 0.34375 1.3125 0 1.75 0H12.25C12.6562 0 13 0.34375 13 0.75V15H13.625ZM4 2.375V3.625C4 3.84375 4.15625 4 4.375 4H5.625C5.8125 4 6 3.84375 6 3.625V2.375C6 2.1875 5.8125 2 5.625 2H4.375C4.15625 2 4 2.1875 4 2.375ZM4 5.375V6.625C4 6.84375 4.15625 7 4.375 7H5.625C5.8125 7 6 6.84375 6 6.625V5.375C6 5.1875 5.8125 5 5.625 5H4.375C4.15625 5 4 5.1875 4 5.375ZM5.625 10C5.8125 10 6 9.84375 6 9.625V8.375C6 8.1875 5.8125 8 5.625 8H4.375C4.15625 8 4 8.1875 4 8.375V9.625C4 9.84375 4.15625 10 4.375 10H5.625ZM8 15V12.375C8 12.1875 7.8125 12 7.625 12H6.375C6.15625 12 6 12.1875 6 12.375V15H8ZM10 9.625V8.375C10 8.1875 9.8125 8 9.625 8H8.375C8.15625 8 8 8.1875 8 8.375V9.625C8 9.84375 8.15625 10 8.375 10H9.625C9.8125 10 10 9.84375 10 9.625ZM10 6.625V5.375C10 5.1875 9.8125 5 9.625 5H8.375C8.15625 5 8 5.1875 8 5.375V6.625C8 6.84375 8.15625 7 8.375 7H9.625C9.8125 7 10 6.84375 10 6.625ZM10 3.625V2.375C10 2.1875 9.8125 2 9.625 2H8.375C8.15625 2 8 2.1875 8 2.375V3.625C8 3.84375 8.15625 4 8.375 4H9.625C9.8125 4 10 3.84375 10 3.625Z"
                fill="#B22222"
              />
            </svg>
          ),
        },
        {
          label: formatPhoneLabel(
            ourCompany?.company?.phone_no || globalJson.phone,
          ),
          href: `tel:${formatTelHref(ourCompany?.company?.phone_no || globalJson.phone)}`,
          icon: (
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.5312 11.3125C15.7812 11.4375 15.9688 11.7188 15.9688 12.0312C15.9688 12.0625 15.9688 12.125 15.9688 12.1875L15.2188 15.4375C15.125 15.7812 14.8438 16 14.5 16C6.46875 16 0 9.53125 0 1.5C0 1.15625 0.21875 0.875 0.5625 0.78125L3.8125 0.03125C3.875 0.03125 3.9375 0 3.96875 0C4.28125 0 4.5625 0.1875 4.6875 0.46875L6.1875 3.96875C6.21875 4.0625 6.25 4.15625 6.25 4.25C6.25 4.5 6.125 4.71875 5.96875 4.84375L4.0625 6.40625C5.21875 8.84375 7.15625 10.7812 9.59375 11.9375L11.1562 10.0312C11.2812 9.875 11.5 9.75 11.7188 9.75C11.8438 9.75 11.9375 9.78125 12.0312 9.8125L15.5312 11.3125Z"
                fill="#B22222"
              />
            </svg>
          ),
        },
        {
          label: ourCompany?.company?.email || globalJson.email,
          href: `mailto:${ourCompany?.company?.email || globalJson.email}`,
          icon: (
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16 14.5C16 15.3438 15.3125 16 14.5 16H1.5C0.65625 16 0 15.3438 0 14.5V6.28125C0 5.8125 0.21875 5.375 0.5625 5.09375C1.34375 4.5 1.96875 4 5.6875 1.3125C6.21875 0.9375 7.25 0 8 0.03125C8.71875 0 9.75 0.9375 10.2812 1.3125C14 4 14.625 4.5 15.4062 5.09375C15.75 5.375 16 5.8125 16 6.28125V14.5ZM13.9375 8.375C13.8438 8.25 13.6875 8.21875 13.5625 8.3125C12.875 8.84375 11.8438 9.59375 10.2812 10.7188C9.75 11.0938 8.71875 12.0312 8 12C7.25 12.0312 6.21875 11.0938 5.6875 10.7188C4.125 9.59375 3.09375 8.84375 2.40625 8.3125C2.28125 8.21875 2.125 8.25 2.03125 8.375L1.75 8.78125C1.71875 8.8125 1.71875 8.875 1.71875 8.9375C1.71875 9 1.75 9.09375 1.8125 9.125C2.53125 9.65625 3.53125 10.4062 5.09375 11.5312C5.75 12 6.875 13.0312 8 13C9.09375 13.0312 10.2188 12 10.875 11.5312C12.4375 10.4062 13.4375 9.65625 14.1562 9.125C14.2188 9.09375 14.25 9 14.25 8.9375C14.25 8.875 14.25 8.8125 14.2188 8.78125L13.9375 8.375Z"
                fill="#B22222"
              />
            </svg>
          ),
        },
        {
          label: "Review us on Google",
          href: `https://maps.app.goo.gl/Np1F6C1RAG2SWizEA?g_st=ic`,
          icon: (
            <svg
              width="16"
              height="15"
              viewBox="0 0 57 50"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M50.7626 12.5034H4.839C3.74784 12.5034 2.86328 13.3912 2.86328 14.4863V47.9499C2.86328 49.0451 3.74784 49.9329 4.839 49.9329H50.7626C51.8537 49.9329 52.7383 49.0451 52.7383 47.9499V14.4863C52.7383 13.3912 51.8537 12.5034 50.7626 12.5034Z"
                fill="#C70419"
              />
              <path
                d="M50.1861 12.2222H5.36022C3.97165 12.2222 2.89111 23.0079 2.89111 24.4015L27.4391 49.9328H50.1861C51.579 49.929 52.7071 48.7967 52.7109 47.3988V14.7557C52.7068 13.3579 51.5788 12.226 50.1861 12.2222Z"
                fill="url(#paint0_linear_127_297)"
              />
              <path
                d="M14.2515 18.7717H28.5015V0.000488281H16.3852L14.2515 18.7717Z"
                fill="#E10019"
              />
              <path
                d="M42.7515 18.7717H28.5015V0.000488281H40.6177L42.7515 18.7717ZM52.7382 3.5588L52.7559 3.62278C52.7516 3.6002 52.7431 3.57923 52.7382 3.5588Z"
                fill="#C20015"
              />
              <path
                d="M52.7559 3.62229L52.7382 3.55831C52.2864 1.48198 50.4554 0.00134418 48.3379 0H40.6177L42.7498 18.7717H56.9998L52.7559 3.62229Z"
                fill="#C20015"
              />
              <path
                d="M4.26475 3.55908L4.24707 3.62306C4.25136 3.60048 4.25993 3.57951 4.26475 3.55908Z"
                fill="#C20015"
              />
              <path
                d="M4.24661 3.62229L4.26429 3.55831C4.71605 1.48198 6.54713 0.00134418 8.66464 0H16.3854L14.25 18.7717H0L4.24661 3.62229Z"
                fill="#C20015"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M14.2757 18.7671C14.2757 22.7142 11.0875 25.9141 7.15467 25.9141C3.22189 25.9141 0.0336914 22.7142 0.0336914 18.7671H14.2757Z"
                fill="#C20015"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M28.5178 18.7671C28.5178 22.7142 25.3296 25.9141 21.3969 25.9141C17.4641 25.9141 14.2759 22.7142 14.2759 18.7671H28.5178Z"
                fill="#E10019"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M42.7595 18.7671C42.7595 22.7142 39.5713 25.9141 35.6386 25.9141C31.7058 25.9141 28.5176 22.7142 28.5176 18.7671H42.7595Z"
                fill="#C20015"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M56.9998 18.7671C56.9998 22.7142 53.8116 25.9141 49.8788 25.9141C45.946 25.9141 42.7578 22.7142 42.7578 18.7671H56.9998Z"
                fill="#E10019"
              />
              <path
                d="M49.8794 38.1301C49.8542 37.7897 49.8124 37.479 49.7529 37.0822H41.9851C41.9851 38.1726 41.9851 39.3624 41.9808 40.4534H46.4808C46.3852 40.9618 46.1905 41.4462 45.9078 41.8789C45.6251 42.3115 45.26 42.6839 44.8335 42.9745C44.8335 42.9745 44.8335 42.9557 44.8303 42.9552C44.2795 43.3181 43.659 43.5612 43.0088 43.6686C42.357 43.7883 41.6887 43.7854 41.0379 43.66C40.3771 43.5228 39.7515 43.2506 39.1999 42.8605C38.3857 42.281 37.7577 41.4757 37.3929 40.5432C37.3651 40.4706 37.3394 40.3975 37.3131 40.3233V40.3152L37.3201 40.3098C36.966 39.2669 36.9651 38.1359 37.3174 37.0924C37.5656 36.3604 37.9739 35.6935 38.5126 35.1406C39.7762 33.8288 41.6641 33.3353 43.4047 33.8621C44.0722 34.0675 44.682 34.4278 45.1849 34.9137L46.7031 33.39C46.971 33.1185 47.249 32.8555 47.5067 32.5749C46.7369 31.8542 45.8333 31.2926 44.8474 30.9221C43.0532 30.2691 41.0904 30.2518 39.2851 30.8731C39.2222 30.8946 39.1597 30.9171 39.0976 30.9403C37.1499 31.6752 35.5476 33.1164 34.6072 34.9793C34.2751 35.6387 34.0333 36.3401 33.8883 37.0644C33.0284 41.3535 35.636 45.5754 39.846 46.7102C41.2222 47.0802 42.6853 47.071 44.0722 46.7549C45.3324 46.4693 46.4976 45.8616 47.4547 44.9908C48.4533 44.0687 49.169 42.8401 49.544 41.5352C49.8575 40.4294 49.9711 39.2761 49.8794 38.1301Z"
                fill="white"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_127_297"
                  x1="2.89111"
                  y1="17522.6"
                  x2="53010.7"
                  y2="17522.6"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="0.03" stop-color="#C20015" />
                  <stop offset="1" stop-color="#8A0110" />
                </linearGradient>
              </defs>
            </svg>
          ),
        },
      ],
    },
  ];

  useEffect(() => {
    // If navigation to `/` included a hash target in state, scroll to it once
    const state: any = location.state as any;
    const scrollTo =
      state && typeof state.scrollTo === "string" ? state.scrollTo : undefined;
    if (location.pathname === "/" && scrollTo) {
      const id = scrollTo.startsWith("#") ? scrollTo.slice(1) : scrollTo;
      // slight delay to ensure DOM is painted
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        } else {
          // fallback: set hash on location
          window.location.hash = scrollTo;
        }
        // clear state so it doesn't trigger again
        navigate(location.pathname, { replace: true, state: {} });
      }, 50);
    }
  }, [location, navigate]);

  const renderWidgetMenuItem = (menu: WidgetFooterMenu, index: number) => {
    return (
      <div key={index} className="text-sm  sm:ml-0 ">
        <h2 className="font-medium text-xl text-neutral-700 dark:text-neutral-200">
          {menu.title}
        </h2>
        <ul className="mt-5 space-y-4">
          {menu.menus.map((item, index) => (
            <li key={index}>
              {item.href ? (
                // For tel/mailto keep default behavior. For hash links, handle navigation and scrolling.
                item.href.startsWith("tel:") ||
                item.href.startsWith("mailto:") ||
                item.href.startsWith("http") ? (
                  <a
                    className="text-[#A9A9A9] hover:text-white  flex items-center gap-2"
                    href={item.href}
                  >
                    {item.icon && (
                      <span className="flex-shrink-0">{item.icon}</span>
                    )}
                    {item.label}
                  </a>
                ) : item.href.startsWith("#") ? (
                  <a
                    className="text-[#A9A9A9] hover:text-white  flex items-center gap-2"
                    href={`/${item.href}`}
                    onClick={(e) => {
                      e.preventDefault();
                      const hash = String(item.href);
                      if (location.pathname === "/") {
                        const id = hash.slice(1);
                        const el = document.getElementById(id);
                        if (el) {
                          el.scrollIntoView({ behavior: "smooth" });
                        } else {
                          window.location.hash = hash;
                        }
                      } else {
                        // navigate to home and pass desired hash in state so we can scroll after route change
                        navigate("/", { state: { scrollTo: hash } });
                      }
                    }}
                  >
                    {item.icon && (
                      <span className="flex-shrink-0">{item.icon}</span>
                    )}
                    {item.label}
                  </a>
                ) : (
                  <a
                    className="text-[#A9A9A9] hover:text-white  flex items-center gap-2"
                    href={`/${item.href}`}
                  >
                    {item.icon && (
                      <span className="flex-shrink-0">{item.icon}</span>
                    )}
                    {item.label}
                  </a>
                )
              ) : (
                <span className="text-[#A9A9A9] hover:text-white break-words flex items-center gap-2">
                  {item.icon && (
                    <span className="flex-shrink-0">{item.icon}</span>
                  )}
                  {item.label}
                </span>
              )}
            </li>
          ))}
        </ul>
      </div>
    );
  };

  return (
    <div className="nc-Footer relative py-8  bg-[#444444]">
      <div className="flex justify-center mb-4">
        <button
          type="button"
          aria-label="Go to home top"
          onClick={() => {
            window.location.href = "https://dfwluxauto.com/";
          }}
          className="inline-flex"
        >
          <img
            className={`w-48 h-[100px] object-contain`}
            src={LogoPic}
            alt="logo"
          />
        </button>
      </div>

      <div className="container border-t border-b border-[#FFFFFF36] py-12 grid grid-cols-2 gap-y-10 gap-x-5 sm:gap-x-8 md:grid-cols-4 lg:gap-x-10 ">
        {widgetMenus.map(renderWidgetMenuItem)}
        <div>
          <h2 className="font-medium text-xl text-neutral-700 dark:text-neutral-200">
            Follow Us
          </h2>
          <div className="flex col-span-2 items-center md:col-span-3 space-x-2 mt-5 ">
            <a href={globalJson.facebook}>
              <svg
                className="mob-wh-35"
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="40" height="40" rx="8" fill="#B22222" />
                <path
                  d="M29.8469 20.5C29.8469 25.3438 26.2922 29.3672 21.6438 30.0703V23.3125H23.9094L24.3391 20.5H21.6438V18.7031C21.6438 17.9219 22.0344 17.1797 23.2453 17.1797H24.4563V14.7969C24.4563 14.7969 23.3625 14.6016 22.2688 14.6016C20.0813 14.6016 18.6359 15.9688 18.6359 18.3906V20.5H16.175V23.3125H18.6359V30.0703C13.9875 29.3672 10.4719 25.3438 10.4719 20.5C10.4719 15.1484 14.8078 10.8125 20.1594 10.8125C25.5109 10.8125 29.8469 15.1484 29.8469 20.5Z"
                  fill="white"
                />
              </svg>
            </a>
            <a href={globalJson.x}>
              <svg
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="mob-wh-35"
              >
                <rect width="40" height="40" rx="8" fill="#B22222" />
                <path
                  d="M11.0303 28.9502L18.5787 21.4018M18.5787 21.4018L11.0303 10.9502H16.0303L21.4819 18.4986M18.5787 21.4018L24.0303 28.9502H29.0303L21.4819 18.4986M29.0303 10.9502L21.4819 18.4986"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </a>
            <a href={globalJson.instagram}>
              <svg
                className="mob-wh-35"
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="40" height="40" rx="8" fill="#B22222" />
                <path
                  d="M20.1516 16.0078C22.6125 16.0078 24.6438 18.0391 24.6438 20.5C24.6438 23 22.6125 24.9922 20.1516 24.9922C17.6516 24.9922 15.6594 23 15.6594 20.5C15.6594 18.0391 17.6516 16.0078 20.1516 16.0078ZM20.1516 23.4297C21.7531 23.4297 23.0422 22.1406 23.0422 20.5C23.0422 18.8984 21.7531 17.6094 20.1516 17.6094C18.5109 17.6094 17.2219 18.8984 17.2219 20.5C17.2219 22.1406 18.55 23.4297 20.1516 23.4297ZM25.8547 15.8516C25.8547 16.4375 25.3859 16.9062 24.8 16.9062C24.2141 16.9062 23.7453 16.4375 23.7453 15.8516C23.7453 15.2656 24.2141 14.7969 24.8 14.7969C25.3859 14.7969 25.8547 15.2656 25.8547 15.8516ZM28.8234 16.9062C28.9016 18.3516 28.9016 22.6875 28.8234 24.1328C28.7453 25.5391 28.4328 26.75 27.4172 27.8047C26.4016 28.8203 25.1516 29.1328 23.7453 29.2109C22.3 29.2891 17.9641 29.2891 16.5188 29.2109C15.1125 29.1328 13.9016 28.8203 12.8469 27.8047C11.8313 26.75 11.5188 25.5391 11.4406 24.1328C11.3625 22.6875 11.3625 18.3516 11.4406 16.9062C11.5188 15.5 11.8313 14.25 12.8469 13.2344C13.9016 12.2188 15.1125 11.9062 16.5188 11.8281C17.9641 11.75 22.3 11.75 23.7453 11.8281C25.1516 11.9062 26.4016 12.2188 27.4172 13.2344C28.4328 14.25 28.7453 15.5 28.8234 16.9062ZM26.9484 25.6562C27.4172 24.5234 27.3 21.7891 27.3 20.5C27.3 19.25 27.4172 16.5156 26.9484 15.3438C26.6359 14.6016 26.05 13.9766 25.3078 13.7031C24.1359 13.2344 21.4016 13.3516 20.1516 13.3516C18.8625 13.3516 16.1281 13.2344 14.9953 13.7031C14.2141 14.0156 13.6281 14.6016 13.3156 15.3438C12.8469 16.5156 12.9641 19.25 12.9641 20.5C12.9641 21.7891 12.8469 24.5234 13.3156 25.6562C13.6281 26.4375 14.2141 27.0234 14.9953 27.3359C16.1281 27.8047 18.8625 27.6875 20.1516 27.6875C21.4016 27.6875 24.1359 27.8047 25.3078 27.3359C26.05 27.0234 26.675 26.4375 26.9484 25.6562Z"
                  fill="white"
                />
              </svg>
            </a>
            <a href={globalJson.tiktok}>
              <svg
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="mob-wh-35"
              >
                <rect width="40" height="40" rx="8" fill="#B22222" />
                <path
                  d="M18.1121 18.6633C17.0622 18.5096 14.6691 18.7639 13.4957 21.0107C12.3222 23.2575 13.5049 25.596 14.2429 26.4843C14.9717 27.3155 17.2881 28.8894 19.7451 27.3527C20.3541 26.9718 21.1128 26.6877 21.9736 23.7114L21.8735 12C21.7074 13.2896 23.0831 16.3144 27 16.6723"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </a>
            <a href={globalJson.youtube}>
              <svg
                className="mob-wh-35"
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="40" height="40" rx="8" fill="#B22222" />
                <path
                  d="M30.3625 15.3828C30.8313 17.0234 30.8313 20.5391 30.8313 20.5391C30.8313 20.5391 30.8313 24.0156 30.3625 25.6953C30.1281 26.6328 29.3859 27.3359 28.4875 27.5703C26.8078 28 20.1672 28 20.1672 28C20.1672 28 13.4875 28 11.8078 27.5703C10.9094 27.3359 10.1672 26.6328 9.93281 25.6953C9.46406 24.0156 9.46406 20.5391 9.46406 20.5391C9.46406 20.5391 9.46406 17.0234 9.93281 15.3828C10.1672 14.4453 10.9094 13.7031 11.8078 13.4688C13.4875 13 20.1672 13 20.1672 13C20.1672 13 26.8078 13 28.4875 13.4688C29.3859 13.7031 30.1281 14.4453 30.3625 15.3828ZM17.9797 23.7031L23.5266 20.5391L17.9797 17.375V23.7031Z"
                  fill="white"
                />
              </svg>
            </a>
          </div>
        </div>
      </div>
      <div className="flex justify-between gap-2 container text-[#A9A9A9] mt-3">
        <p>{ourCompany?.company?.name}</p>
        <p>Copyright © 2026 All rights reserved.</p>
      </div>
    </div>
  );
};

export default Footer;
